/** Regras de apresentação da faixa. Nada disso é regra de jogo. */
export const AvisoRegras = {
  duracaoMs: { nota: 5_000, aviso: 8_000, urgente: 15_000, evento: 10_000 },
  urgenteFechaSozinha: false,
  filaMax: 5,
  repeticaoMs: 3_000,
  somUrgente: true
} as const;

export const Realce = {
  Nenhum: 0,
  Aviso: 1,
  Urgente: 2,
  Nota: 3
} as const;

export type RealceFaixa = typeof Realce.Aviso | typeof Realce.Urgente | typeof Realce.Nota;

export function ehRealceFaixa(n: number): n is RealceFaixa {
  return n === Realce.Aviso || n === Realce.Urgente || n === Realce.Nota;
}

/**
 * Os avisos dos eventos (Ultimate Battle, chefe do mundo, Pentagrama e o evento anunciado pelo GM) têm faixa própria:
 * cor de evento e saem sozinhos depois de `duracaoMs.evento`, sem botão de fechar (Renato, 26/10). Os números são os
 * `NoticeCode` de `Realtime/Protocol/Wire.cs`. A recusa do altar (202) fica de fora: é um erro do jogador.
 */
const CODIGOS_DE_EVENTO: ReadonlySet<number> = new Set([
  106, 109, 110, 115,
  177, 178, 179, 180, 181, 182,
  183, 184, 185, 186, 187, 188,
  193, 194, 195, 196, 197, 198, 199, 200, 201, 203, 205
]);

export function ehAvisoDeEvento(code: number): boolean {
  return CODIGOS_DE_EVENTO.has(code);
}

export function duracaoDoRealce(realce: RealceFaixa): number {
  if (realce === Realce.Urgente) return AvisoRegras.duracaoMs.urgente;
  if (realce === Realce.Nota) return AvisoRegras.duracaoMs.nota;
  return AvisoRegras.duracaoMs.aviso;
}

export function nomeDoRealce(realce: RealceFaixa): 'aviso' | 'urgente' | 'nota' {
  if (realce === Realce.Urgente) return 'urgente';
  if (realce === Realce.Nota) return 'nota';
  return 'aviso';
}
